import { render, staticRenderFns } from "./_Banner.vue?vue&type=template&id=4d22b496&"
import script from "./_Banner.vue?vue&type=script&lang=js&"
export * from "./_Banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports